// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cae2fcc6","816":"3d0db79f"}[chunkId] + ".chunk.js";
};